export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 2,
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px',
    },
    appContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 4,
        textDecoration: 'none',
        color: 'inherit',
    },
    appIconContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 1,
    },
    appIcon: {
        width: '80px',
        height: '80px',
    },
    appTitle: {
        fontSize: '14px',
        textAlign: 'center',
        fontWeight: 600,
    },
    descriptionContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 1,
    },
    shortDescription: {
        fontSize: '14px',
        fontWeight: 600,
        fontStyle: 'italic',
    },
    description: {
        whiteSpace: 'pre-line',
    },
};
